import React from 'react';
import { FeatureSidebarButton } from '@lmt/signal-viewer-ui';
import { saveChartsAsJpeg } from '../utils/save-charts-as-jpeg';

const ImageExportIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 3C16.1046 3 17 3.89543 17 5V15C17 16.0357 16.2128 16.887 15.2041 16.9893L15 17H5L4.7959 16.9893C3.85435 16.8938 3.1062 16.1457 3.01074 15.2041L3 15V5C3 3.89543 3.89543 3 5 3H15ZM5 4C4.44772 4 4 4.44772 4 5V15C4 15.5523 4.44772 16 5 16H15C15.5523 16 16 15.5523 16 15V5C16 4.44772 15.5523 4 15 4H5ZM7.21875 10.0869C7.39706 9.96532 7.6384 9.9701 7.8125 10.1094L12.8125 14.1094C13.0281 14.2819 13.0631 14.5969 12.8906 14.8125C12.7181 15.0281 12.4031 15.0631 12.1875 14.8906L7.53613 11.1699L5.85352 12.8535C5.65825 13.0488 5.34175 13.0488 5.14648 12.8535C4.95122 12.6583 4.95122 12.3417 5.14648 12.1465L7.14648 10.1465L7.21875 10.0869ZM12.5 5C13.8807 5 15 6.11929 15 7.5C15 8.88071 13.8807 10 12.5 10C11.1193 10 10 8.88071 10 7.5C10 6.11929 11.1193 5 12.5 5ZM12.5 6C11.6716 6 11 6.67157 11 7.5C11 8.32843 11.6716 9 12.5 9C13.3284 9 14 8.32843 14 7.5C14 6.67157 13.3284 6 12.5 6Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const DownloadJpegButton: React.FC = () => {
  return (
    <FeatureSidebarButton
      icon={<ImageExportIcon />}
      label='Download as JPEG'
      onClick={() => saveChartsAsJpeg('signal-viewer__charts')}
    />
  );
};
